import State from 'store/State';
import { useSelector } from 'react-redux';

import {
    ExpertiseComponentState,
    initialExpertiseComponentState,
} from './ExpertiseComponentState';
import { selectWidgetComponentState } from 'widgets/store/component/selectors';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetType } from 'widgets/WidgetType';

export const selectExpertiseComponentState = (
    state: State,
    widgetType: WidgetType,
    widgetKey: string
) => {
    return (
        selectWidgetComponentState<ExpertiseComponentState>(
            state,
            widgetType,
            widgetKey
        ) ?? initialExpertiseComponentState
    );
};

export const useSelectQuickSearchText = () => {
    const { widgetType, widgetKey } = useWidgetContext();
    return useSelector(
        (state: State) =>
            selectExpertiseComponentState(state, widgetType, widgetKey)
                .quickSearchText
    );
};
